<template>
  <div>
    <Modal
      v-model="visible"
      :closeBtn="closeBtn"
      :hasFooter="false"
      @on_cancel="closeModal"
      width="360px">
      <template slot="body">
        <div
          v-if="!closeBtn"
          class="showCode"
          :class="showCode ? 'code_yes' : 'code_no'"
          @click="changeShowCode">
        </div>
        <!-- 登录 -->
        <div v-if="currentTab === 1">
          <LoginTpl
            :clean="visible"
            :showCode="showCode"
            @toChangeTab="toChangeTab"
            @go_enroll="goEnroll"
            @login_success="loginSuccessHandler"
            @on_cancel="closeModal"
          />
        </div>
        <!-- 忘记密码 -->
        <div v-if="currentTab === 3">
          <ForgetTpl
            :clean="visible"
            @toChangeTab="toChangeTab"
            @go_enroll="goEnroll"
            @login_success="loginSuccessHandler"
            @on_cancel="closeModal"
          />
        </div>
      </template>
    </Modal>
  </div>
</template>
<script>
import Modal from './Modal.vue'
import LoginTpl from './login/index.vue'
import ForgetTpl from './forget/index.vue'
export default {
  name: 'CmineLogin',
  data() {
    return {
      visible: this.value,
      // 是否展示二维码登录
      showCode: false,
      closeBtn: false,
      // 1登录、2注册、3忘记密码
      currentTab: 1
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value: function(val) {
      this.visible = val
      this.currentTab = 1
    },
    currentTab: function(val) {
      this.closeBtn = val === 3 ? true : false
    }
  },
  model: {
    prop: 'value',
    event: 'on_cancel'
  },
  mounted() {
    this.$store.commit('SET_LOGINMODAL', false)
  },
  methods: {
    loginSuccessHandler(flag) {
      this.$emit('login_success', flag)
    },
    goLogin() {
      this.$emit('go_login')
    },
    goEnroll() {
      this.$emit('go_enroll')
    },
    closeModal: function() {
      this.visible = false
      this.$emit('on_cancel')
      // this.$store.commit('SET_USER_VERIFY', false)
      this.$store.commit('SET_LOGINMODAL', false)
    },
    // 去注册或登录
    toChangeTab (val) {
      this.currentTab = val
    },
    // 切换验证码登录
    changeShowCode() {
      this.showCode = !this.showCode
    }
  },
  components: { Modal, LoginTpl, ForgetTpl }
}
</script>
<style scoped lang="scss">
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 1.4s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.showCode {
  position: absolute;
  right: 0;
  top: 0;
  width: 65px;
  height: 65px;
  cursor: pointer;
}
.code_yes {
  background: url(../../assets/images/code_no.png) no-repeat;
  background-size: 100% 100%;
}
.code_no {
  background: url(../../assets/images/code_yes.png) no-repeat;
  background-size: 100% 100%;
}
/deep/ .modal-content {
  height: 500px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
  background: blue;
}
.fade-enter, .fade-leave-to /* .fade-leave-active 在低于版本 2.1.8 中 */ {
  opacity: 0;
  width: 200px;
  background: red;
}
</style>
